(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-about-video"] && !Shopify.designMode) return;
  try {
    
  const video = document.getElementById("video");
  const circlePlayButton = document.getElementById("circle-play-b");
    function togglePlay() {
    if (video.paused || video.ended) {
    video.play();
    } else {
    video.pause();
    }
  }
    circlePlayButton.addEventListener("click", togglePlay);
    video.addEventListener("playing", function () {
    circlePlayButton.style.opacity = 0;
  });
    video.addEventListener("pause", function () {
    circlePlayButton.style.opacity = 1;
  });

  } catch(e) { console.error(e); }
})();
})();
